import { getAnalyticsPathData } from 'utils/analytics/pathUtils';

export const getPageDataTrackingKey = (pathname = '') => {
  const { path, page } = getAnalyticsPathData(pathname);

  if (!page) {
    return null;
  }

  return `${path}|${page}`;
};

export const createPageDataEmitter = (trackPageData, shouldTrackPath = () => true) => {
  let lastKey = null;
  return (isAuthenticated, pathname = window.location.pathname) => {
    lastKey = emitPageDataIfNeeded({
      isAuthenticated,
      pathname,
      lastTrackedKey: lastKey,
      shouldTrackPath,
      trackPageData,
    });
  };
};

export const emitPageDataIfNeeded = ({
  isAuthenticated,
  pathname = window.location.pathname,
  lastTrackedKey,
  shouldTrackPath = () => true,
  trackPageData,
}) => {
  if (!isAuthenticated) {
    return lastTrackedKey;
  }

  if (!shouldTrackPath(pathname)) {
    return lastTrackedKey;
  }

  const nextKey = getPageDataTrackingKey(pathname);
  if (!nextKey || nextKey === lastTrackedKey) {
    return lastTrackedKey;
  }

  trackPageData();
  return nextKey;
};
